import { render } from "./homekpi3.vue?vue&type=template&id=baf5a096"
import script from "./homekpi3.vue?vue&type=script&lang=js"
export * from "./homekpi3.vue?vue&type=script&lang=js"

import "./homekpi3.vue?vue&type=style&index=0&id=baf5a096&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__